import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Archive } from "lucide-react";
import { useTranslation } from "react-i18next";
import useSurvey from "../hooks/useSurvey";
import ConfirmDialog from "@/components/confirm-dialog";

interface ArchiveAlertProps {
  show?: boolean;
}

export default function ArchiveAlert({ show }: ArchiveAlertProps) {
  const { t } = useTranslation();
  const questionnnaire = useSurvey();
  const onRestore = () => {
    questionnnaire.setArchiveFlag(false);
  };
  if (!show) {
    return null;
  }
  return (
    <Alert className="bg-yellow-100 text-yellow-900 border-yellow-300">
      <Archive className="w-5 h-5" color="#713f12" />
      <AlertTitle>{t("surveyEditor.archived.title")}</AlertTitle>
      <AlertDescription className="flex items-center place-content-between">
        {t("surveyEditor.archived.description")}

        <ConfirmDialog
          title={t("surveyEditor.restoreDialog.title")}
          yesLabel={t("surveyEditor.restoreDialog.yesButton")}
          noLabel={t("surveyEditor.restoreDialog.noButton")}
          content={t("surveyEditor.restoreDialog.content")}
          onConfirm={onRestore}
        >
          <Button type="button" variant="outline">
            {t("surveyEditor.archived.restoreButtonLabel")}
          </Button>
        </ConfirmDialog>
      </AlertDescription>
    </Alert>
  );
}
